import { FC, ReactElement } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useOktaAuth } from '@okta/okta-react'
import { useQuery } from '@tanstack/react-query'
import OktaAuth from '@okta/okta-auth-js'

interface Props {
  element: ReactElement
}

const checkUserLoggedIn = async (oktaAuth: OktaAuth): Promise<boolean> => {
  const isAuthenticated = await oktaAuth.isAuthenticated()

  return isAuthenticated
}

const AuthRequired: FC<Props> = ({ element }) => {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { data, isFetched } = useQuery({
    queryKey: ['checkUserLoggedIn', authState],
    queryFn: () => checkUserLoggedIn(oktaAuth),
    enabled: !!authState,
  })

  if (!data && isFetched) {
    localStorage.setItem('originalUrl', pathname)

    void navigate('/login')
  }

  return <>{element}</>
}

export default AuthRequired
